import { render } from "./fb-vog-talk-icon.svg?vue&type=template&id=db9100bc"
const script = {}
script.render = render

export default script